// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-image-style[data-v-19af4b30]{width:50px;height:50px;-o-object-fit:scale-down;object-fit:scale-down;padding-bottom:7px}.table-shadow[data-v-19af4b30]{border:2px solid rgba(0,128,0,.35)}.make-green[data-v-19af4b30]{color:#4abca5}.brand[data-v-19af4b30]{color:#837d89}.content-box[data-v-19af4b30]{text-align:center;margin:60px 25px 60px 25px}", ""]);
// Exports
module.exports = exports;
